import { render, staticRenderFns } from "./RejectAndDeleteModal.vue?vue&type=template&id=81f42404&"
import script from "./RejectAndDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./RejectAndDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports